import { createSlice } from '@reduxjs/toolkit';

// import useMediaQuery from '@mui/material/useMediaQuery';

import { loadTheme, saveTheme } from '../../services/storage';

// const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

const theme = loadTheme();

const initialState = {
  // theme: theme ? theme : prefersDarkMode ? 'dark' : 'light',
  theme: theme,
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { setTheme } = themeSlice.actions;

export const themeSelector = (state) => state.theme;

export const selectTheme = (theme) => (dispatch, getState) => {
  const currentTheme = themeSelector(getState().theme);
  if (currentTheme !== theme) {
    saveTheme(theme);
    dispatch(setTheme(theme));
  }
};

export default themeSlice.reducer;
